module.exports = __webpack_public_path__ + "static/media/home-service-slider-10.d4021a51.jpg";